<section>
  <!-- Page Header -->
  <div class="packages-header">
    <div class="container">
      <span class="pkg-label">{{ 'packs.label' | translate }}</span>
      <h2>{{ 'packs.header' | translate }}</h2>
    </div>
  </div>

  <div class="container">
    <div *ngIf="showMessage" class="text-center">
      <h1>{{ 'packs.coming' | translate }}</h1>
    </div>

    <div class="row" *ngIf="!showMessage">
      <div
        class="col-6 col-md-4 col-lg-3 pack"
        *ngFor="let item of allPackages"
        (click)="pack_details(item?.id)"
      >
        <div class="cardStyle">
          <img [src]="item?.image" [alt]="item?.name" />
          <h2>{{ item?.name }}</h2>
        </div>
      </div>
    </div>
  </div>
</section>
